import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CartButton from '../../components/feature/CartButton';

export default function BlogPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchPreview, setShowSearchPreview] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setSubmitMessage('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d5t0pmdvmu9mcvg4n3o0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Thank you for subscribing! Check your inbox for wellness tips.');
        setEmail('');
      } else {
        setSubmitMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Unable to subscribe. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const shareOnFacebook = (post: any) => {
    const url = `${window.location.origin}/blog/${post.id}`;
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank', 'width=600,height=400');
  };

  const shareOnWhatsApp = (post: any) => {
    const url = `${window.location.origin}/blog/${post.id}`;
    const text = `${post.title} - ${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  const shareOnInstagram = () => {
    window.open('https://www.instagram.com/healthyliving.products?igsh=NGl6a3oxZXhrcmxr', '_blank');
  };

  const blogPosts = [
    {
      id: 2,
      title: 'Erectile Dysfunction: Causes and Natural Solutions',
      excerpt:
        'Understanding the causes of ED and how Ayurvedic medicine offers natural, holistic solutions for men\'s sexual health and vitality. Discover how FS-Desire Capsules can help restore your confidence and performance.',
      image:
        'https://public.readdy.ai/ai/img_res/3b8292927fcefd7f444a5a341eaea4d3.jpg',
      category: 'Men\'s Health',
      date: 'March 18, 2025',
      readTime: '5 min read',
      recommendedProduct: 'FS-Desire Capsule - Specially formulated with 14 Ayurvedic remedies to address impotency, premature ejaculation, and improve sexual strength. Safe for hypertensive and diabetic patients.'
    },
    {
      id: 3,
      title: 'Natural Weight Loss: Ayurvedic Approach to Healthy Weight Management',
      excerpt:
        'Discover how Ayurvedic medicine addresses the root causes of weight gain through natural herbs, metabolism boosting, and holistic wellness. Learn how Clean Detox can support your weight loss journey by burning belly fat and detoxifying your body.',
      image:
        'https://readdy.ai/api/search-image?query=person%20standing%20on%20bathroom%20scale%20looking%20down%20with%20measuring%20tape%20around%20waist%20surrounded%20by%20healthy%20vegetables%20and%20fruits%20weight%20loss%20journey%20realistic%20lifestyle%20photography%20natural%20lighting&width=800&height=600&seq=blog-weight-realistic-journey&orientation=landscape',
      category: 'Weight Management',
      date: 'March 20, 2025',
      readTime: '7 min read',
      recommendedProduct: 'Clean Detox - Contains Kachnar guggul, Varunchal and Choti Elaichi that help burn stomach fats, boost digestion, and support healthy weight management.'
    },
    {
      id: 4,
      title: 'Managing Diabetes Naturally: Ayurvedic Approach to Blood Sugar Control',
      excerpt:
        'Learn how Ayurvedic remedies can support healthy blood sugar levels, activate the pancreas, and help manage diabetes naturally. Discover how Clean Detox with Gilloy can help control blood sugar effectively.',
      image:
        'https://readdy.ai/api/search-image?query=person%20checking%20blood%20glucose%20meter%20at%20breakfast%20table%20with%20healthy%20meal%20insulin%20pen%20and%20diabetes%20medication%20realistic%20medical%20lifestyle%20photography%20morning%20natural%20lighting&width=800&height=600&seq=blog-diabetes-realistic-management&orientation=landscape',
      category: 'Blood Sugar & Diabetes',
      date: 'March 22, 2025',
      readTime: '8 min read',
      recommendedProduct: 'Clean Detox - Fortified with Gilloy which is highly effective for blood sugar control and helps manage diabetes naturally while detoxifying your body.'
    },
    {
      id: 5,
      title: 'Managing High Blood Pressure Naturally: Ayurvedic Solutions for Heart Health',
      excerpt:
        'Explore natural ways to support cardiovascular health and maintain healthy blood pressure through Ayurvedic herbs and lifestyle changes. Learn how Noni Juice can help normalize blood pressure and support heart health.',
      image:
        'https://readdy.ai/api/search-image?query=doctor%20checking%20patient%20blood%20pressure%20with%20sphygmomanometer%20in%20medical%20office%20patient%20looking%20concerned%20hypertension%20monitoring%20realistic%20healthcare%20photography%20professional%20setting&width=800&height=600&seq=blog-bp-realistic-checkup&orientation=landscape',
      category: 'Heart Health',
      date: 'March 24, 2025',
      readTime: '7 min read',
      recommendedProduct: 'Noni Juice - Traditionally used to treat high blood pressure, heart diseases, and improve circulation. Reduces cholesterol and triglycerides naturally.'
    },
    {
      id: 6,
      title: 'Boosting Your Immune System: Natural Defense Against Infections and Diseases',
      excerpt:
        'Strengthen your body\'s natural defenses with powerful Ayurvedic herbs that build immunity and protect against infections and diseases. Discover how Vita Trace (Double Stemcell+) can rejuvenate your immune system.',
      image:
        'https://readdy.ai/api/search-image?query=person%20with%20cold%20and%20flu%20symptoms%20holding%20tissue%20box%20surrounded%20by%20medicine%20bottles%20looking%20unwell%20at%20home%20depicting%20weak%20immune%20system%20realistic%20medical%20lifestyle%20photography&width=800&height=600&seq=blog-immunity-realistic-illness&orientation=landscape',
      category: 'Immunity',
      date: 'March 26, 2025',
      readTime: '6 min read',
      recommendedProduct: 'Vita Trace (Double Stemcell+) - Combines multiple fruit stem cells with 16 Ayurvedic remedies to boost immune system, repair damaged tissues, and provide wholistic rejuvenation.'
    },
    {
      id: 7,
      title: 'Body Detoxification: Cleanse Your System Naturally with Ayurvedic Wisdom',
      excerpt:
        'Discover how to eliminate toxins, support liver function, and rejuvenate your body through natural Ayurvedic detoxification methods. Learn how Clean Detox can help cleanse your entire body and fight free radicals.',
      image:
        'https://readdy.ai/api/search-image?query=person%20looking%20tired%20and%20bloated%20holding%20stomach%20with%20digestive%20discomfort%20surrounded%20by%20unhealthy%20processed%20foods%20depicting%20toxin%20buildup%20realistic%20lifestyle%20photography%20natural%20lighting&width=800&height=600&seq=blog-detox-realistic-need&orientation=landscape',
      category: 'Detox & Cleanse',
      date: 'March 28, 2025',
      readTime: '7 min read',
      recommendedProduct: 'Clean Detox - Age-old Ayurvedic formulation designed to stimulate digestive fire, promote bile flow, liver detoxification, and cleanse your whole body while fighting free radicals.'
    },
    {
      id: 8,
      title: 'Cancer Prevention: Natural Support and Ayurvedic Approach to Cellular Health',
      excerpt:
        'Learn about cancer prevention strategies and how Ayurvedic remedies can support cellular health and strengthen your body\'s natural defenses. Discover how Noni Juice can help prevent cellular damage and support cancer prevention.',
      image:
        'https://readdy.ai/api/search-image?query=cancer%20patient%20with%20supportive%20family%20member%20holding%20hands%20in%20hospital%20consultation%20room%20pink%20ribbon%20cancer%20awareness%20symbol%20hope%20and%20strength%20realistic%20healthcare%20photography%20compassionate%20setting&width=800&height=600&seq=blog-cancer-realistic-support&orientation=landscape',
      category: 'Cancer Prevention',
      date: 'March 30, 2025',
      readTime: '9 min read',
      recommendedProduct: 'Noni Juice - Helps prevent cellular damage caused by smoking, prevents cancer, and contains powerful antioxidants. Fortified with Brahmi and Alma for enhanced protection.'
    },
    {
      id: 9,
      title: 'Natural Relief for Toothache and Dental Problems: Ayurvedic Solutions',
      excerpt:
        'Discover natural Ayurvedic remedies for toothache, gum disease, and dental problems. Learn how to maintain oral health naturally and how Noni Juice can help reduce dental plagues and treat mouth sores.',
      image:
        'https://readdy.ai/api/search-image?query=person%20holding%20jaw%20in%20severe%20dental%20pain%20with%20swollen%20cheek%20sitting%20in%20dentist%20waiting%20room%20realistic%20medical%20photography%20depicting%20toothache%20and%20oral%20health%20concern&width=800&height=600&seq=blog-dental-realistic-pain&orientation=landscape',
      category: 'Dental Health',
      date: 'April 1, 2025',
      readTime: '6 min read',
      recommendedProduct: 'Noni Juice - Helps reduce dental plagues, treats cancer sores, and can be applied directly to affected areas for relief. Contains Aloe vera for healing properties.'
    },
    {
      id: 10,
      title: 'Joint Pain, Arthritis & Osteoporosis: Natural Ayurvedic Solutions for Bone Health',
      excerpt:
        'Learn how Ayurvedic medicine can help manage joint pain, arthritis, and osteoporosis naturally through powerful herbs and lifestyle changes. Discover how Noni Juice can reduce chronic pain and swelling in joints.',
      image:
        'https://readdy.ai/api/search-image?query=elderly%20person%20holding%20painful%20knee%20with%20visible%20discomfort%20sitting%20on%20chair%20arthritis%20joint%20pain%20realistic%20medical%20photography%20depicting%20bone%20and%20joint%20health%20concern%20natural%20lighting&width=800&height=600&seq=blog-joint-realistic-arthritis&orientation=landscape',
      category: 'Joint & Bone Health',
      date: 'April 3, 2025',
      readTime: '8 min read',
      recommendedProduct: 'Noni Juice - Reduces chronic pain and swelling, treats rheumatoid arthritis, and helps with muscle aches and pains. Contains anti-inflammatory properties for joint health.'
    },
    {
      id: 11,
      title: 'Women\'s Reproductive Health: Natural Ayurvedic Support for Hormonal Balance',
      excerpt:
        'Discover how Ayurvedic medicine supports women\'s reproductive health, hormonal balance, fertility, and menstrual wellness naturally. Learn how Vita Trace can help regulate reproductive system and hormonal balance.',
      image:
        'https://readdy.ai/api/search-image?query=woman%20experiencing%20menstrual%20cramps%20lying%20on%20bed%20holding%20lower%20abdomen%20in%20discomfort%20hot%20water%20bottle%20nearby%20depicting%20hormonal%20imbalance%20and%20reproductive%20health%20issues%20realistic%20medical%20photography&width=800&height=600&seq=blog-womens-realistic-health&orientation=landscape',
      category: 'Women\'s Health',
      date: 'April 5, 2025',
      readTime: '7 min read',
      recommendedProduct: 'Vita Trace (Double Stemcell+) - Supports reproductive system, helps with hormonal balance, and provides wholistic rejuvenation for women\'s health concerns.'
    },
    {
      id: 12,
      title: 'Natural Relief for Piles (Hemorrhoids): Ayurvedic Treatment and Prevention',
      excerpt:
        'Learn about natural Ayurvedic remedies for piles, hemorrhoids, and digestive health. Discover effective treatments and prevention strategies using Noni Juice for inflammatory conditions of the digestive system.',
      image:
        'https://readdy.ai/api/search-image?query=person%20sitting%20uncomfortably%20on%20cushion%20with%20visible%20discomfort%20depicting%20hemorrhoids%20and%20digestive%20health%20issues%20realistic%20medical%20photography%20natural%20lighting%20emphasizing%20digestive%20concern&width=800&height=600&seq=blog-piles-realistic-discomfort&orientation=landscape',
      category: 'Digestive Health',
      date: 'April 7, 2025',
      readTime: '6 min read',
      recommendedProduct: 'Noni Juice - Treats piles and inflammatory conditions of the digestive system. Helps with constipation, dysentery, and accelerates wound healing in the digestive tract.'
    }
  ];

  // Filter blog posts based on search query
  const filteredPosts = blogPosts.filter(post => 
    post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
    post.category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Get preview results (limit to 5 for dropdown)
  const previewResults = searchQuery.trim() ? filteredPosts.slice(0, 5) : [];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" 
                alt="Organic Natural Solution Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                About
              </Link>
              <Link
                to="/products"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Products
              </Link>
              <Link
                to="/testimonials"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Testimonials
              </Link>
              <Link
                to="/blog"
                className="text-sm font-medium text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className="text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => window.scrollTo(0, 0)}
              >
                Contact
              </Link>
              <CartButton />
            </div>
            <div className="flex md:hidden items-center gap-4">
              <CartButton />
              <button
                className="cursor-pointer"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <i
                  className={`${
                    mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
                  } text-2xl text-gray-900`}
                ></i>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link
                to="/"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                About
              </Link>
              <Link
                to="/products"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Products
              </Link>
              <Link
                to="/testimonials"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Testimonials
              </Link>
              <Link
                to="/blog"
                className="block text-sm font-medium text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors"
                onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Wellness <span className="text-teal-600">Insights</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Explore the latest in herbal medicine, Ayurvedic wisdom, and
              natural wellness
            </p>
            
            {/* Search Bar with Live Preview */}
            <div className="max-w-2xl mx-auto relative">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search for health topics, conditions, or remedies..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setShowSearchPreview(true)}
                  onBlur={() => setTimeout(() => setShowSearchPreview(false), 200)}
                  className="w-full px-6 py-4 pr-14 rounded-full border-2 border-gray-200 focus:border-teal-600 focus:outline-none text-sm"
                />
                <button className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 bg-teal-600 text-white rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer">
                  <i className="ri-search-line text-xl"></i>
                </button>
              </div>

              {/* Search Preview Dropdown */}
              {showSearchPreview && previewResults.length > 0 && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden z-50">
                  {previewResults.map((post) => (
                    <Link
                      key={post.id}
                      to={`/blog/${post.id}`}
                      className="flex items-start gap-4 p-4 hover:bg-teal-50 transition-colors cursor-pointer border-b border-gray-100 last:border-b-0"
                      onClick={() => {
                        setShowSearchPreview(false);
                        window.scrollTo(0, 0);
                      }}
                    >
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-20 h-20 object-cover object-center rounded-lg flex-shrink-0"
                      />
                      <div className="flex-1 min-w-0">
                        <span className="text-xs font-medium text-teal-600 mb-1 block">
                          {post.category}
                        </span>
                        <h4 className="text-sm font-bold text-gray-900 mb-1 line-clamp-2">
                          {post.title}
                        </h4>
                        <p className="text-xs text-gray-500">{post.readTime}</p>
                      </div>
                    </Link>
                  ))}
                  {filteredPosts.length > 5 && (
                    <div className="p-3 text-center bg-gray-50">
                      <button
                        onClick={() => {
                          setShowSearchPreview(false);
                          document.getElementById('blog-grid')?.scrollIntoView({ behavior: 'smooth' });
                        }}
                        className="text-sm text-teal-600 font-medium hover:underline cursor-pointer"
                      >
                        View all {filteredPosts.length} results
                      </button>
                    </div>
                  )}
                </div>
              )}

              {searchQuery && (
                <p className="text-sm text-gray-600 mt-3">
                  Found {filteredPosts.length} article{filteredPosts.length !== 1 ? 's' : ''} matching "{searchQuery}"
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Subscription Section */}
      <section className="py-16 bg-gradient-to-br from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-bold text-white mb-4">
              Stay Updated with Wellness Tips
            </h2>
            <p className="text-xl text-teal-50">
              Subscribe to our newsletter and receive exclusive health insights, natural remedies, and special offers directly to your inbox
            </p>
          </div>

          <form 
            id="newsletter-form" 
            data-readdy-form 
            onSubmit={handleNewsletterSubmit}
            className="max-w-2xl mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="flex-1 px-6 py-4 rounded-full border-2 border-white/20 bg-white/10 text-white placeholder-white/60 focus:border-white focus:outline-none text-sm backdrop-blur-sm"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-white text-teal-600 px-8 py-4 rounded-full font-bold hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe Now'}
              </button>
            </div>
            
            {submitMessage && (
              <div className={`mt-4 p-4 rounded-2xl text-center ${
                submitMessage.includes('Thank you') 
                  ? 'bg-white/20 text-white' 
                  : 'bg-red-500/20 text-white'
              }`}>
                {submitMessage}
              </div>
            )}

            <p className="text-sm text-teal-50 text-center mt-4">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </form>
        </div>
      </section>

      {/* Blog Grid */}
      <section id="blog-grid" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {filteredPosts.length === 0 ? (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">No articles found</h3>
              <p className="text-gray-600 mb-6">Try searching with different keywords</p>
              <button
                onClick={() => setSearchQuery('')}
                className="bg-teal-600 text-white px-8 py-3 rounded-full font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Clear Search
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <div key={post.id} className="group">
                  <Link
                    to={`/blog/${post.id}`}
                    className="block cursor-pointer"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div className="rounded-3xl overflow-hidden mb-6">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-64 object-cover object-center group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="flex items-center gap-4 mb-3">
                      <span className="text-sm font-medium text-teal-600">
                        {post.category}
                      </span>
                      <span className="text-sm text-gray-400">{post.date}</span>
                      <span className="text-sm text-gray-400">{post.readTime}</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-4">
                      {post.excerpt}
                    </p>
                    <span className="text-teal-600 font-medium group-hover:underline">
                      Read More →
                    </span>
                  </Link>

                  {/* Social Sharing Buttons */}
                  <div className="flex items-center gap-3 mt-4 pt-4 border-t border-gray-100">
                    <span className="text-sm text-gray-500 font-medium">Share:</span>
                    <button
                      onClick={() => shareOnFacebook(post)}
                      className="w-9 h-9 flex items-center justify-center bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors cursor-pointer"
                      aria-label="Share on Facebook"
                    >
                      <i className="ri-facebook-fill text-base"></i>
                    </button>
                    <button
                      onClick={() => shareOnWhatsApp(post)}
                      className="w-9 h-9 flex items-center justify-center bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors cursor-pointer"
                      aria-label="Share on WhatsApp"
                    >
                      <i className="ri-whatsapp-line text-base"></i>
                    </button>
                    <button
                      onClick={shareOnInstagram}
                      className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-purple-600 to-pink-500 text-white rounded-full hover:from-purple-700 hover:to-pink-600 transition-colors cursor-pointer"
                      aria-label="Follow us on Instagram"
                    >
                      <i className="ri-instagram-line text-base"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <img src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" alt="Organic Natural Solution Logo" className="h-12 w-auto mb-6" />
              <p className="text-gray-400 leading-relaxed mb-6">
                Dedicated to providing the highest quality herbal remedies that honor traditional wisdom while meeting modern wellness needs.
              </p>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/healthyliving.products?igsh=NGl6a3oxZXhrcmxr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://www.facebook.com/share/1CKjLukjVr/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">LOCATION</h4>
                <p className="text-gray-400">#2 Allen Avenue Near Tonyin Roundabout, Ikeja, Lagos - Nigeria</p>
              </div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">PHONE</h4>
                <p className="text-gray-400">+234 815 435 8746</p>
                <p className="text-gray-400">+234 913 789 7299</p>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase mb-3">EMAIL</h4>
                <p className="text-gray-400">healthyliving.hello@gmail.com</p>
              </div>
            </div>

            <div>
              <div className="rounded-2xl overflow-hidden h-80">
                <img 
                  src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6686b80771a03e2f4f8c9b19d31144a1.jpeg" 
                  alt="Organic Natural Solution" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8">
            <p className="text-sm text-gray-400 text-center">© 2025 Organic Natural Solution. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <button
        onClick={() => window.open('https://wa.me/2348154358746', '_blank')}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-all hover:scale-110 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>
    </div>
  );
}
